import { useLocation } from 'react-router-dom';
import { 
    CHIEF_PREV,
    HEAD_MEMBERS, 
    FINTECH_MEMBERS, 
    FINBUSS_MEMBERS, 
    FINLAW_MEMBERS, 
    INDUSTRY_MEMBERS,
    ADVISORY_MEMBERS
} from '../Components/info_all_members';

import {
    Flex,
    chakra,
    Box,
    Text,
    Tag,
    Link,
    HStack,
    VStack,
    Image,
} from '@chakra-ui/react';
import ReviewWarning from '../Components/ReviewWarning';
import { useLanguage } from '../i18n/LanguageContext';
import { getLocalizedMember } from '../i18n/translations';

const PersonalPage = () => {
    const { language, t } = useLanguage();
    const location = useLocation();
    const { index, group } = location.state;

    let person;
    if(group === 'Chief') {
        person = CHIEF_PREV[index];
    }
    else if (group === 'Head') {
        person = HEAD_MEMBERS[index];
    }
    else if (group === 'FinTech') {
        person = FINTECH_MEMBERS[index];
    }
    else if (group === 'FinBuss') {
        person = FINBUSS_MEMBERS[index];
    }
    else if (group === 'FinLaw') {
        person = FINLAW_MEMBERS[index];
    }
    else if (group === 'Industry') {
        person = INDUSTRY_MEMBERS[index];
    }
    else if (group === 'Advisory') {
        person = ADVISORY_MEMBERS[index];
    }

    const displayPerson = getLocalizedMember(person, language);

    return (
        <Box
            bg="#edf3f8"
            p={10}
            w="auto"
        >
            <Box
                shadow="xl"
                bg="white"
                mx="auto"
            >
                {/* RWD: md 以上版本 */}
                <Flex
                    display={{ base: 'none', md: 'flex' }}
                    p={10}
                >
                    <Flex
                        w={1 / 3}
                    >
                        <Image width='70%' src={displayPerson.avatar} alt={displayPerson.name_ch} />
                    </Flex>

                    <Box
                        w={2 / 3}
                        padding={10}
                        p={{
                            textAlign: 'left',
                            overflowX: 'overlay',
                        }}
                    >
                        <chakra.h1
                            fontSize="3xl"
                            fontWeight="bold"
                            color="gray.800"
                        >
                            {displayPerson.name_ch}
                        </chakra.h1>
                        <chakra.h2
                            fontSize="xl"
                            fontWeight="bold"
                            color="gray.800"
                        >
                            {displayPerson.name_en}
                        </chakra.h2>

                        <chakra.p
                            mt={3}
                            fontSize="sm"
                            color="gray.600"
                        >
                            <HStack>
                                <Tag size={'lg'} key={'lg'} variant='solid' colorScheme='teal'>
                                    {t('common.title')}
                                </Tag>
                                <Text fontSize='lg'>{displayPerson.title}<ReviewWarning message={displayPerson.warning} /></Text>
                            </HStack>
                            <HStack mt={2}>
                                <Tag size={'lg'} key={'lg'} variant='solid' colorScheme='teal'>
                                    {t('common.email')}
                                </Tag>
                                <Text fontSize='lg'>{displayPerson.email}</Text>
                            </HStack>
                            <HStack mt={2}>
                                <Tag size={'lg'} key={'lg'} variant='solid' colorScheme='teal'>
                                    {t('common.expertise')}
                                </Tag>
                                <Text fontSize='lg'>{displayPerson.expertise}</Text>
                            </HStack>
                            <HStack mt={2}>
                                <Tag size={'lg'} key={'lg'} variant='solid' colorScheme='teal'>
                                    {t('common.website')}
                                </Tag>
                                <Link fontSize='lg' href={displayPerson.website} isExternal>{displayPerson.website}</Link>
                            </HStack>
                        </chakra.p>
                    </Box>
                </Flex>
                {/* RWD: md 以下版本 */}
                <VStack
                    bg="white"
                    overflow="hidden"
                    display={{ md: 'none' }}
                >
                    <Image width='100%' src={displayPerson.avatar} alt={displayPerson.name_ch} />
                    <Box
                        p={{
                            textAlign: 'left',
                            overflowX: 'overlay',
                        }}
                        padding='3'
                    >
                        <chakra.h1
                            fontSize="2xl"
                            fontWeight="bold"
                            color="gray.800"
                        >
                            {displayPerson.name_ch}
                        </chakra.h1>
                        <chakra.h2
                            fontSize="xl"
                            fontWeight="bold"
                            color="gray.800"
                        >
                            {displayPerson.name_en}
                        </chakra.h2>

                        <chakra.p
                            mt={3}
                            fontSize="sm"
                            color="gray.600"
                        >
                            <HStack>
                                <Tag size={'lg'} key={'lg'} variant='solid' colorScheme='teal'>
                                    {t('common.title')}
                                </Tag>
                                <Text fontSize='lg'>{displayPerson.title}<ReviewWarning message={displayPerson.warning} /></Text>
                            </HStack>
                            <HStack mt={2}>
                                <Tag size={'lg'} key={'lg'} variant='solid' colorScheme='teal'>
                                    {t('common.email')}
                                </Tag>
                                <Text fontSize='lg'>{displayPerson.email}</Text>
                            </HStack>
                            <HStack mt={2}>
                                <Tag size={'lg'} key={'lg'} variant='solid' colorScheme='teal'>
                                    {t('common.expertise')}
                                </Tag>
                                <Text fontSize='lg'>{displayPerson.expertise}</Text>
                            </HStack>
                            <HStack mt={2}>
                                <Tag size={'lg'} key={'lg'} variant='solid' colorScheme='teal'>
                                    {t('common.website')}
                                </Tag>
                                <Link fontSize='lg' href={displayPerson.website} isExternal>{displayPerson.website}</Link>
                            </HStack>
                        </chakra.p>
                    </Box>
                </VStack>
                
                <chakra.p
                    mb={6}
                    p={10}
                    fontSize={{
                        base: "lg",
                        md: "xl",
                    }}
                    textAlign={{
                        base: "center",
                        sm: "left",
                    }}
                    color="gray.600"
                >
                    {person.bio}
                </chakra.p>
            </Box>
        </Box>
    );
}
export default PersonalPage;
